import React from 'react';

import SPBreadcrumb from 'components/base/SPBreadcrumb';
import SPSearchForm from 'components/order-management/order-list/search-form';
import SPTable from 'components/order-management/order-list/table';
import SPDrawer from 'components/order-management/order-list/drawer';
// import SPPageActionBar from "components/order-management/order-list/page-action-bar";
import SPModal from '../../../components/order-management/order-list/modals/car-platoon-modal';
import CarPlatoonModal from '../../../components/order-management/order-list/modals/car-platoon-modal';
import DriverPlatoonModal from '../../../components/order-management/order-list/modals/driver-platoon-modal';
import FreeRenewalModal from '../../../components/order-management/order-list/modals/free-renewal-modal';
// import GetContactInformationModal from '../../../components/order-management/order-list/modals/get-contact-information-modal';
import OrderDeductionModal from '../../../components/order-management/order-list/modals/order-deduction-modal';
import OrderRefundModal from '../../../components/order-management/order-list/modals/order-refund-modal';
import RemarkModal from '../../../components/order-management/order-list/modals/remark-modal';
import ThawDeposiModal from '../../../components/order-management/order-list/modals/thaw-deposi-modal';
import RefundOfDepositDeductionModal from '../../../components/order-management/order-list/modals/refund-of-deposit-deduction';
import SPContentWrap from "../../../components/carRental/base/SPContentWrap";

interface IPageProps {
	enums?: any;
	permission?: any;
}

const SPPage: React.FC<IPageProps> = props => {
	const { enums, permission } = props;

	return (
		<>
			<SPBreadcrumb title="订单列表" />
			<SPContentWrap className='common-margin-top'>
				<SPSearchForm enums={enums} />
			</SPContentWrap>
			{/* <SPPageActionBar></SPPageActionBar> */}
			<SPTable enums={enums} permission={permission} />
			<SPDrawer permission={permission} enums={enums} />
			{/*查看订单详情*/}

			{/*排车/改排*/}
			<CarPlatoonModal enums={enums}></CarPlatoonModal>

			{/*排司机*/}
			<DriverPlatoonModal enums={enums}></DriverPlatoonModal>

			{/*取车，订单详情-取车信息录入*/}

			{/*免费续租*/}
			<FreeRenewalModal enums={enums}></FreeRenewalModal>


			{/*还车，订单详情-还车信息录入*/}

			{/*订单信息，订单备注*/}

			<RemarkModal></RemarkModal>

			{/*订单信息，费用详情，订单扣款 */}
			<OrderDeductionModal enums={enums}></OrderDeductionModal>

			{/*订单信息，费用详情，订单退款 */}
			<OrderRefundModal enums={enums}></OrderRefundModal>

			{/*订单信息，费用详情，订单退款 */}
			<ThawDeposiModal enums={enums}></ThawDeposiModal>
			{/*押金扣款后退款 */}

			<RefundOfDepositDeductionModal enums={enums} ></RefundOfDepositDeductionModal>

		</>
	);
};

export default SPPage;
